import useSWR from 'swr';
import { OffenseFragment } from '@amf/shared/types/graphql';

const API_PATH = '/api/offense/list';

const getPath = (leagueId: string | null, seasonId: string | null, playerId: string | null) => {
  const params = new URLSearchParams({});
  if (leagueId && leagueId !== '-') params.append('league', leagueId);
  if (seasonId && seasonId !== '-') params.append('season', seasonId);
  if (playerId) params.append('player', playerId);
  return `${API_PATH}?${params.toString()}`;
};

function useOffenseList(
  leagueId: string | null,
  seasonId: string | null,
  playerId: string | null = null,
) {
  const { data, error } = useSWR<OffenseFragment[] | null>(getPath(leagueId, seasonId, playerId));
  return { offenses: data ?? [], error, loading: !data && !error };
}

export default useOffenseList;
